import { Component, Host, h, Build, Prop, State } from '@stencil/core'
import { sitemapRows } from '~/components/organism/wf-footer/sitemap.data'

/**
 * Represents the footer container.
 */
@Component({
    tag: 'wf-footer',
    styleUrl: 'wf-footer.scss',
    scoped: true,
})
// eslint-disable-next-line require-jsdoc
export class WfFooter {
    private csrfToken: string

    @Prop() paybackServiceStatus: string

    @State() paybackActive = true

    @State() sitemapRows = sitemapRows

    /**
     * @inheritDoc
     */
    componentWillLoad() {
        this.csrfToken = Build.isBrowser && window.CSRF.getToken()
        if (this.paybackServiceStatus === 'inactive') {
            this.paybackActive = false
        }
        if (!this.paybackActive) {
            delete this.sitemapRows[0].columns[2].sections[1]
        }
    }

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div>
                    <wf-newsletter-subscription
                        placeholder="Deine E-Mail-Adresse"
                        csrfToken={this.csrfToken}
                        couponValue={10}
                        action="/EmarsysNewsletter/subscribe"
                        paybackActive={this.paybackActive}
                    />
                    <wf-shop-awards lazyLoadImages={true}/>

                    <section>
                        <wf-contact-display/>
                        <wf-payment-methods/>
                        <wf-shipping/>
                        <wf-social-media/>
                    </section>

                    <wf-footer-sitemap rows={sitemapRows} />

                    <wf-footer-disclaimer/>
                </div>
            </Host>
        )
    }
}
